import './api-format.service.js';
import './format-appointments.service.js';
import './merge-projects.service.js';



// WEBPACK FOOTER //
// ./components/appointments/util/index.js